<template>
  <div class="top-bar">
    <header id="header" :style="computeBackgroundColor">
      <div class="back-container" :class="{ disabled: didJustLogin }">
        <button
          class="back-btn"
          @click="goBack"
          :class="{ disabled: didJustLogin }"
        >
          <svg
            role="img"
            focusable="false"
            height="24"
            width="24"
            viewBox="0 0 24 24"
          >
            <polyline
              points="16 4 7 12 16 20"
              fill="none"
              stroke="#fff"
            ></polyline>
          </svg>
        </button>
        <button class="forwards-btn" @click="goForwards">
          <svg
            role="img"
            focusable="false"
            height="24"
            width="24"
            viewBox="0 0 24 24"
          >
            <polyline
              points="8 4 17 12 8 20"
              fill="none"
              stroke="#fff"
            ></polyline>
          </svg>
        </button>
        <div class="shop-actions" v-if="shouldShowShopActions">
          <span class="artist-name"> {{ getTitle }} </span>
          <follow-button
            size="sm"
            :withBell="true"
            :shop="getShop"
            v-if="!isLikesPage && !isFeedPage && !isListPage"
          />
        </div>
      </div>
      <div class="search" v-if="isSearchPage">
        <div class="form-wrapper">
          <input
            type="text"
            name="search"
            id="search"
            maxlength="75"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
            placeholder="Artists, tv shows, or youtubers."
            v-model.trim="query"
            ref="searchField"
          />
          <div class="overlay">
            <span>
              <svg
                height="24"
                role="img"
                width="24"
                viewBox="0 0 512 512"
                aria-hidden="true"
              >
                <path
                  d="M349.714 347.937l93.714 109.969-16.254 13.969-93.969-109.969q-48.508 36.825-109.207 36.825-36.826 0-70.476-14.349t-57.905-38.603-38.603-57.905-14.349-70.476 14.349-70.476 38.603-57.905 57.905-38.603 70.476-14.349 70.476 14.349 57.905 38.603 38.603 57.905 14.349 70.476q0 37.841-14.73 71.619t-40.889 58.921zM224 377.397q43.428 0 80.254-21.461t58.286-58.286 21.461-80.254-21.461-80.254-58.286-58.285-80.254-21.46-80.254 21.46-58.285 58.285-21.46 80.254 21.46 80.254 58.285 58.286 80.254 21.461z"
                  fill="currentColor"
                ></path>
              </svg>
            </span>
            <button class="clear" v-if="hasSearchQuery" @click="clearSearch">
              <svg height="24" role="img" width="24" viewBox="0 0 24 24">
                <path
                  d="M4.93,4.93,19.07,19.07m-14.14,0L19.07,4.93"
                  fill="none"
                  stroke="currentColor"
                  stroke-miterlimit="10"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div class="right-side">
        <transition name="fade">
          <div v-if="shouldShowShopActions && isFeedPage">
            <sort-dropdown />
          </div>
        </transition>
        <notification-menu class="notification-menu" />
        <profile-dropdown />
      </div>
    </header>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FollowButton from "@/components/FollowButton.vue";
import SortDropdown from "./SortDropdown.vue";
import ProfileDropdown from "./ProfileDropdown.vue";
import NotificationMenu from "./NotificationMenu.vue";
export default {
  name: "Topbar",
  components: {
    FollowButton,
    SortDropdown,
    ProfileDropdown,
    NotificationMenu,
  },
  data() {
    return {
      scrollPosition: null,
      win: null,
      route: "",
      query: "",
      timeout: null,
    };
  },
  created() {
    if (this.route === "") {
      this.route = this.$router.currentRoute.name;
    }
  },
  watch: {
    $route: function (newRoute, oldRoute) {
      this.route = newRoute.name;

      if (this.route != "Search") {
        this.query = "";
      } else {
        if (newRoute.params.query !== undefined) {
          this.query = newRoute.params.query;
        }
      }
    },
    query: function (value) {
      if (this.route == "Search") {
        clearTimeout(this.timeout);

        var self = this;
        this.timeout = setTimeout(function () {
          self.trackEvent("Search", "Search", value);
          self.$router.replace({ path: `/search/${value}` });
        }, 450);
      }
    },
  },
  mounted() {
    this.win = document.getElementById("main");

    this.$nextTick(function () {
      this.win.addEventListener("scroll", this.onScroll);
    });
  },
  beforeDestroy() {
    this.$nextTick(function () {
      this.win.removeEventListener("scroll", this.onScroll);
    });
  },
  computed: {
    ...mapGetters({
      getShop: "shop/getShop",
      getList: "list/getList",
      didJustLogin: "auth/didJustLogin",
    }),
    computeBackgroundColor() {
      if (this.isFeedPage) {
        return {
          backgroundColor: `white`,
        };
      }

      if (this.isProfilePage) {
        return {
          backgroundColor: `transparent`,
        };
      }

      var heightConst = 0;
      if (this.isSearchPage) {
        heightConst = 80.0;
      } else {
        heightConst = 180.0;
      }
      const alpha =
        Math.max(this.scrollPosition, heightConst) / heightConst - 1.0;
      return {
        backgroundColor: `rgba(255,255,255,${alpha})`,
      };
    },
    shouldShowShopActions() {
      if (this.isLikesPage) {
        return this.scrollPosition > 300;
      } else if (this.isSearchPage) {
        return false;
      } else if (this.isFeedPage) {
        return true;
      } else if (this.isProfilePage) {
        return false;
      } else {
        return this.scrollPosition > 420;
      }
    },
    getTitle() {
      if (this.isLikesPage) {
        return "My Likes";
      } else if (this.isFeedPage) {
        return "My Feed Test";
      } else if (this.isListPage) {
        return this.getList.name;
      } else {
        return this.getShop.name;
      }
    },
    hasSearchQuery() {
      return this.isSearchPage && this.query.length > 0;
    },
    isFeedPage() {
      return this.route === "Feed";
    },
    isLikesPage() {
      return this.route === "Likes";
    },
    isSearchPage() {
      return this.route === "Search";
    },
    isProfilePage() {
      return this.route === "Profile";
    },
    isListPage() {
      return this.route === "List";
    },
  },
  methods: {
    onScroll() {
      this.scrollPosition = this.win.scrollTop;
    },
    clearSearch() {
      this.trackEvent("Search", "Clear Query", this.query);
      this.query = "";
      if (this.$refs.searchField) {
        this.$refs.searchField.focus();
      }
    },
    goBack() {
      this.$router.go(-1);
      this.trackEvent("Navigation", "Back", this.route);
    },
    goForwards() {
      this.$router.go(1);
      this.trackEvent("Navigation", "Forward", this.route);
    },
  },
};
</script>

<style lang="scss" scoped>
.top-bar {
  grid-area: main-view;
  height: 60px;
  z-index: 999;
  min-width: 0;
  pointer-events: none;
  width: calc(100% - 10px);
  background: transparent;
  header {
    // background-color: rgb(168, 32, 152);
    // opacity: 0;
    display: flex;
    height: 60px;
    justify-content: space-between;
    max-width: calc(100vw - #{$nav_width});
    padding: 16px;
    padding-inline-end: 16px;
    position: relative;
    width: 100%;
    z-index: 3;
    align-items: center;
    .back-container {
      display: flex;
      pointer-events: auto;
      align-items: center;
      white-space: nowrap;
      &.disabled {
        cursor: not-allowed;
      }
      .back-btn {
        margin-right: 16px;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.6);
        border: none;
        border-radius: 50%;
        color: #fff;
        cursor: pointer;
        display: inline-flex;
        height: 32px;
        justify-content: center;
        position: relative;
        width: 32px;
        &.disabled {
          background: rgba(0, 0, 0, 0.45);
          pointer-events: none;
        }
        svg {
          height: 22px;
          opacity: 1;
          width: 22px;
          stroke-width: 1pt;
        }
      }
      .forwards-btn {
        margin-right: 0;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.6);
        border: none;
        border-radius: 50%;
        color: #fff;
        cursor: pointer;
        display: inline-flex;
        height: 32px;
        justify-content: center;
        position: relative;
        width: 32px;
        svg {
          height: 22px;
          opacity: 1;
          width: 22px;
          stroke-width: 1pt;
        }
      }
      .shop-actions {
        display: flex;
        align-items: center;
        .play {
          margin-right: 20px;
          background-color: #1db954;
          color: white;
          justify-content: center;
          align-items: center;
          font-size: 8px;
          border-radius: 50%;
          border: 0;
          height: 40px;
          min-width: 40px;
          width: 40px;
          &:hover {
            transform: scale(1.04);
          }
        }
        .artist-name {
          color: #000;
          font-size: 24px;
          font-weight: 700;
          letter-spacing: -0.04em;
          line-height: 28px;
          overflow: hidden;
          padding: 0 16px;
          text-overflow: ellipsis;
          transition: opacity 0.5s;
          pointer-events: all;
          opacity: 1;
        }
        .follow-btn {
          margin-bottom: 2px;
        }
      }
    }
    .right-side {
      display: flex;
      align-items: center;
      .profile-btn {
        background-color: rgba(0, 0, 0, 0.7);
        border: 0;
        border-radius: 23px;
        color: #fff;
        cursor: pointer;
        height: 32px;
        margin-inline-start: 32px;
        padding: 2px;
        position: relative;
        pointer-events: auto;
        &:hover {
          background-color: rgba(0, 0, 0, 0.5);
          // background-color: $primary1;
          transition: all 0.2s ease-in;
        }
        .profile-wrapper {
          width: 28px;
          height: 28px;
          display: inline-block;
          position: relative;
          img {
            border-radius: 50%;
            height: 100%;
            object-fit: cover;
            width: 100%;
          }
        }
      }
    }
  }
}

.search {
  display: flex;
  align-items: center;
  pointer-events: none;
  flex: 1;
  margin-left: 16px;
  .form-wrapper {
    flex: 0 1 364px;
    position: relative;
    pointer-events: auto;
    input {
      font-size: 14px;
      font-weight: 400;
      letter-spacing: normal;
      line-height: 16px;
      text-transform: none;
      border: 0;
      border-radius: 500px;
      color: #000;
      height: 40px;
      padding: 6px 48px;
      text-overflow: ellipsis;
      width: 100%;
      box-shadow: 0px 1px 8px 1px #bbbbbbbb;
    }
    .overlay {
      align-items: center;
      bottom: 0;
      display: flex;
      left: 12px;
      pointer-events: none;
      position: absolute;
      right: 12px;
      top: 0;
      span {
        color: #121212;
        flex: 1;
      }
      .clear {
        background-color: transparent;
        border: 0;
        color: #121212;
        padding: 0;
        pointer-events: auto;
      }
    }
  }
}

.notification-menu {
  margin-right: 12px;
  margin-left: 18px;
}
</style>
